import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import {
  flexEnd,
  flexStart,
  SPACE_COMPACT,
  SPACE_COZY,
  SPACE_MINIMUM,
  SPACE_RELAXED,
  textTransformLowercase,
} from '@/styles';
import { PAGE_ADVANCE_VERTICAL_PADDING } from '@/components/primitive/page';

import { BASE_SLOS_PAGE_SIZE } from '../constants';

export const iconSizeAlignStyles = css`
  scale: 1.1;
  ${flexStart};
`;

export const iconSizeAlignFixStyles = css`
  margin-right: 2px;
  padding: 0 2px;
`;

export const cohortTitleStyles = css`
  padding: 0 ${SPACE_COMPACT}px;
  min-height: 48px;
`;

export const filterBarStyles = css`
  padding: ${SPACE_COMPACT}px ${SPACE_COZY}px;
`;

export const cohortMemberRowsStyles = css`
  li {
    cursor: pointer;
    transition-duration: 100ms;
    &:hover {
      background-color: ${token('color.background.input.hovered')};
      & > div:last-of-type a {
        opacity: 1;
      }
    }
    & > div:last-of-type {
      a {
        transition-duration: 100ms;
        opacity: 0;
      }
      span:last-of-type {
        &,
        & svg {
          width: 14px;
          height: 14px;
        }
      }
    }
  }
`;
// header and row shared styles
export const cohortMemberRowStyles = [
  flexStart,
  css`
    & > div {
      ${flexEnd};
      &:nth-of-type(1) {
        width: 150px;
        flex-shrink: 0;
        ${flexStart};
        padding-left: ${SPACE_COMPACT}px;
      }
      &:nth-of-type(2) {
        width: 150px;
        flex-shrink: 0;
      }
      &:nth-of-type(3) {
        width: 200px;
        flex-shrink: 0;
      }
      /* lowest priority: the only column allowed to sacrifice space - truncates
         (clips) instead of wrapping onto a second line when space is tight */
      &:nth-of-type(4) {
        width: 300px;
        min-width: 0;
        overflow: hidden;
        ${flexStart};
        padding-left: ${SPACE_RELAXED * 2}px;
      }
      &:nth-of-type(5) {
        width: 150px;
        flex-shrink: 0;
        ${flexStart};
      }
      &:nth-of-type(6) {
        width: 250px;
        flex-shrink: 0;
      }
      &:last-of-type {
        width: 80px;
        flex-shrink: 0;
        margin-left: auto;
        padding-right: ${SPACE_COMPACT}px;
      }
    }
  `,
];

export const actionStyles = css`
  font-size: 12px;
  font-weight: 500;
`;

export const messageStyles = css`
  font-size: 13px;
  text-transform: none;
  font-weight: 500;
  padding: 1px;
  flex-wrap: nowrap;
`;

export const tagStyles = css`
  span {
    ${textTransformLowercase};
    font-size: 12px;
    font-weight: 600;
    max-width: none !important;
  }
`;

export const percentSignStyles = css`
  font-weight: 500;
  font-size: 12px;
  color: ${token('color.text.subtlest')};
`;

export const secondaryTextStyles = css`
  color: ${token('color.text.subtlest')};
  font-weight: 300;
`;

export const primaryTextStyles = css`
  font-size: 16px;
`;

export const stickyHeadStyles = css`
  h4 {
    font-weight: 500;
  }
  padding-top: ${PAGE_ADVANCE_VERTICAL_PADDING}px;
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: ${token('color.text.inverse')};
`;

// Calculate the entire block height to avoid any kind of page scrolling
// movement when switching pagination: 48px for header, 27px for filter bar,
// SPACE_COZY for gap, 48px for each row.
export const baseSloCohortPlaceholderStyles = css`
  min-height: ${48 + 27 + SPACE_COZY + BASE_SLOS_PAGE_SIZE * 48}px;
`;

export const mimirFilterStyles = css`
  margin-left: ${SPACE_COMPACT}px;
`;

export const dagGraphContainerStyles = css`
  padding: ${SPACE_MINIMUM}px 0;
`;

export const anchorStyles = css`
  position: absolute;
  top: -${SPACE_COZY}px;
`;
